import React from 'react'
import "./EmpireStateSection.css";
import EmpireStateImage from '../../assets/images/empire-state-building-hd-min.png'
import tcSticker from '../../assets/images/tc-sticker-yellow.svg'
// import EmpireStateImageGreen from '../../assets/images/empire-state-building-green-hd-min.png'
// import tripLine from '../../assets/images/tripline-anim.svg'


const EmpireStateSection = () => {

  // const [isGreen, setIsGreen] = useState(false);
  // const [isHidden, setIsHidden] = useState(true);

  //   //use effect to get the state from local storage
  //   useEffect(() => {

  //     const isGreen = JSON.parse(localStorage.getItem('isGreen'));
  //     const isHidden = JSON.parse(localStorage.getItem('isHidden'));
  
  //     if(isGreen && isHidden) {
  //       setIsGreen(isGreen);
  //       setIsHidden(isHidden);
  //     }else {
  //       setIsGreen(false);
  //       setIsHidden(true);
  //     }
      
  
  //   }, [])
  

  //function to toggle the state of the image
  // const toggleImage = () => {

  //   setIsHidden(!isHidden);
  //   setIsGreen(!isGreen);

  //   //save the state to local storage
  //   localStorage.setItem('isGreen', JSON.stringify(isGreen));
  //   localStorage.setItem('isHidden', JSON.stringify(isHidden));

  // }

//use checkbox with id switcherx to toggle the state of the image
//  const toggleImageCheckbox = () => {
//     const checkbox = document.getElementById('switcherx');
//     checkbox.checked = !checkbox.checked;
//     checkbox.addEventListener('click', toggleImage);
//  }


return (
<div> 
    <div className='uk-section uk-height-viewport uk-padding-remove-bottom'>
        <div className='uk-container uk-container-large'>
                 <div className=" uk-child-width-1-1 uk-grid uk-grid-stack">

                     <div className="" uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-small; delay: 200; offset-top: 100; repeat: true;">

                     <div className="uk-grid uk-grid-collapse uk-grid-match uk-height-viewport uk-margin-remove" >

                          <div className="uk-width-2-5@l uk-width-1-1@m uk-flex-top uk-flex uk-scrollspy-inview" >

                              <div className=''> 
                              
                                <div className='trip-ultra trip-heading-display copy-margin-bottom' uk-scrollspy-class="uk-animation-slide-bottom-medium"> 
                                Thanks in part to the millions of travelers that visited NYC…
                                </div> 


                               <div className='trip-heading-one ' uk-scrollspy-class="uk-animation-slide-top-medium">
                                  ...the Empire State Building was named <br className="uk-visible@l"/> the #1 attraction <br className="uk-visible@l"/>in the U.S. 
                              </div>
                              
                              </div>


                          </div>


                          <div className="uk-width-1-5@l uk-width-1-1@m uk-width-1-2@s uk-text-center uk-flex uk-flex-bottom uk-margin-auto" uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-small; delay: 600; offset-top: 100; repeat: true;">

                            <div className='badge-holder' uk-scrollspy-class="uk-animation-scale-down">
                              <img src={tcSticker} alt='Trip Unpacked' className='' loading='eager' />
                            </div>

                            <div className='empire-state-building' >
                                <img src={EmpireStateImage} alt='empire-state-building' className='empire-state-image' loading='eager' />
                            </div>

                            {/* <div className='empire-state-building' hidden={isHidden} >
                                <img src={EmpireStateImageGreen} alt='empire-state-building' className='empire-state-image' loading='eager' />
                            </div> */}

                          </div>



                          <div className="uk-width-2-5@l uk-width-1-2@m uk-width-1-2@s uk-flex uk-flex-bottom uk-margin-large-bottom uk-visible@l" >


                            {/* <div className=''>
                                    <div className='trip-heading-one uk-text-right@l uk-text-center' > 
                                    The Empire State Building won Travelers’ Choice Best of the Best Attraction in the U.S.
                                    </div> */}

                                    {/* <div className='uk-text-right@l uk-text-center'>
                                      Use the switch below to see the Empire State Building lights go up!
                                      <div className="switch_box box_1">
                                          <input id="switcherx" type="checkbox" onClick={toggleImage} className="switch_1"/>
                                      </div>
                                    </div> */}

                            {/* </div> */}


                              
                          </div>

                      </div>


                  </div>
            </div>
        </div>
    </div>


        <div className='trip-heading-one trip-ultra thick-borders uk-text-center text-no-wrap trip-background-mustard'>
            <div uk-parallax="target: #test-start-end; x: 500; easing: 0;" className='trip-ultra move-left'> 

            <div style={{marginLeft:"-400px"}} className="trip-ultra" >
            Travelers’ Choice Best of the Best • Travelers’ Choice Best of the Best • Travelers’ Choice Best of the Best  Travelers’ Choice Best of the Best • Travelers’ Choice Best of the Best • Travelers’ Choice Best of the Best 
            </div>
            
            </div> 
        </div>


</div>
    
  )
}

export default EmpireStateSection